<template>

  <v-container id="container">
    <div>
      <ValidationObserver v-slot="{handleSubmit}">
      <v-form @submit.prevent="handleSubmit(
        ()=>{
          if (work_order) showConfirmSaveWithWorkOrder=true;
        else save()
        })">
    <v-row class="mb-6 align-start">
      <v-col cols="12" md="7" class="text-left">
        <h1 class="text-h4 font-weight-bold">{{id > 0 ? `Cotización #${id}` : 'Nueva Cotización'}}</h1>
        <div v-if='id > 0' class="text-caption grey--text text--darken-1 mt-1">
          <span class="mr-4"><v-icon x-small class="mr-1">fas fa-user-edit</v-icon> {{salesNote.created_by_full_name}}</span>
          <span><v-icon x-small class="mr-1">fas fa-calendar-alt</v-icon>{{salesNote.created_at | moment('DD/MM/YYYY HH:mm')}}</span>
        </div>
      </v-col>
      <v-col cols="12" md="5" class="text-right">
        <div class="d-flex justify-end align-center">
          <v-btn  
            v-if="$can('duplicate', 'SalesNote') && id > 0" 
            class="mr-3" 
            color="primary" 
            outlined
            depressed
            @click="duplicate"
          >
            <v-icon left small>fas fa-clone</v-icon>
            Duplicar
          </v-btn>
          
          <v-btn 
            :loading="saveLoading" 
            color="primary" 
            depressed
            type="submit" 
            class="mr-3 px-6"
            :disabled="(exist_product_below_cost) && !$can('save_product_below_cost', 'SalesNote')"
          >
            <v-icon left small>fas fa-save</v-icon>
            Guardar
          </v-btn>

          <v-btn @click.prevent="$router.push('/sales')" depressed fab small color="grey lighten-4">
            <v-icon color="grey darken-2" small>fas fa-times</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-card outlined class="pa-6 mb-6">
      <div class="text-overline grey--text mb-4">Información General</div>
      <v-row>
        <v-col cols="12" md="4">
          <customer-complete2 v-model='customer' :customer_name="customer.name" :status="true" />
          <div v-if="customer" class="mt-2 d-flex align-center">
            <v-chip v-if="customer.seller" x-small color="grey lighten-4" class="mr-2">
              <v-icon x-small class="mr-1">fas fa-user-tie</v-icon>
              {{customer.seller.first_name}} {{customer.seller.last_name}}
            </v-chip>
            <v-chip v-if="customer.payment" x-small color="grey lighten-4">
              <v-icon x-small class="mr-1">fas fa-credit-card</v-icon>
              {{customer.payment == 0 ? 'Contado' : `${customer.payment} días`}}
            </v-chip>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="contact"
            dense
            :items="customer.contacts"
            item-text="first_name"
            item-value="id"
            label="Contacto"
            outlined
            clearable
            hide-details
            :disabled="!customer"
          >
            <template v-slot:item="{ item }">
              <span>{{item.first_name}} {{item.last_name}}</span>
            </template>
            <template v-slot:selection="{ item }">
              <span>{{item.first_name}} {{item.last_name}}</span>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" md="4">
          <ValidationProvider name="Condicion de Pago" rules='required|max:200' v-slot="{ errors }">
            <v-text-field 
              dense
              v-model='payment_condition'
              label='Condición de Pago (Opcional)'
              outlined
              clearable
              hide-details="auto"
              :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider name="Proyecto" rules='required|max:200' v-slot="{ errors }">
            <v-text-field 
              dense
              v-model='name'
              label='Nombre del Proyecto' 
              outlined
              clearable
              hide-details="auto"
              prepend-inner-icon="fas fa-folder-open"
              :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="3">
          <ValidationProvider name="Origen" rules='required' v-slot="{ errors }">
            <origin-selection
              v-model="origin"
              :loading="loading"
              :disabled="loading"
              :errors="errors"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="3">
          <ValidationProvider name="Fecha Prob Cierre" rules='required' v-slot="{ errors }">
            <v-text-field
              dense
              label='Probable Cierre'
              v-model='closing_date'
              type="date"
              outlined
              hide-details="auto"
              :error-messages="errors"  
            ></v-text-field>
          </ValidationProvider>
        </v-col>
      </v-row>
    </v-card>
    <v-row class="mb-6">
      <v-col cols="12" sm="6" md="2">
        <v-card outlined class="pa-3 h-100 text-center grey lighten-5">
          <div class="text-overline grey--text">Total Mts²</div>
          <div class="text-h6 font-weight-bold">{{proyectMts2 | number('0,0.00')}}</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="2" v-if="$can('readCost', 'SalesNote')">
        <v-card outlined class="pa-3 h-100 text-center grey lighten-5">
          <div class="text-overline grey--text">Costo Total</div>
          <div class="text-h6 font-weight-bold">{{proyectCost | moneda}}</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-card outlined class="pa-3 h-100 text-center" :class="proyectPrice > proyectCost ? 'grey lighten-5' : 'error lighten-5'">
          <div class="text-overline grey--text">Valor Venta</div>
          <div class="text-h6 font-weight-bold" :class="proyectPrice > proyectCost ? '' : 'error--text'">{{proyectPrice | moneda}}</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-card outlined class="pa-3 h-100 text-center grey lighten-5">
          <div class="text-overline grey--text">Desc. (%)</div>
          <div class="d-flex align-center justify-center">
            <v-text-field 
              dense
              hide-details
              outlined
              class='white text-center'
              type='number' 
              v-model="discount"
              @input="calculateProyectTotals"
              :disabled="!$can('apply_discount', 'SalesNote')"
              style="width: 70px"
            />
            <span class="ml-2 text-caption grey--text">(-{{proyectTotalDiscount | moneda}})</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-card outlined class="pa-3 h-100 text-center primary lighten-5 primary--text">
          <div class="text-overline primary--text opacity-70">Total Neto</div>
          <div class="text-h5 font-weight-black">{{proyectTotal | moneda}}</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="2" v-if="$can('readCost', 'SalesNote')">
        <v-card outlined class="pa-3 h-100 text-center d-flex flex-column justify-center" :class="proyectMargin > 0.3 ? 'success lighten-5' : (proyectMargin > 0.1 ? 'warning lighten-5' : 'error lighten-5')">
          <div class="text-overline grey--text">Margen</div>
          <v-chip
            pill
            small
            :color="proyectMargin > 0.3 ? 'success' : (proyectMargin > 0.1 ? 'warning' : 'error')"
            class="font-weight-bold align-self-center mt-1"
          >
            {{proyectMargin | percent(1)}}
          </v-chip>
        </v-card>
      </v-col>
    </v-row>
        
          
        <v-row justify="center mt-6">
      <v-data-table
        :loading="loading"
        :headers="productsTableHeaders"
        :items="products"
        :single-expand="true"
        expanded.sync="expanded"
        expand-icon="fas fa-chevron-down"
        item-key="key"
        show-expand
        class="modern-table border rounded overflow-hidden elevation-0 mt-4 grow"
      >
        <template v-slot:top>
          <div class="d-flex align-center px-4 py-3 bg-light border-bottom">
            <v-icon small class="mr-2" color="primary">fas fa-boxes</v-icon>
            <span class="text-subtitle-2 font-weight-bold">Productos de la Cotización</span>
            <v-spacer></v-spacer>
            <v-btn 
              :disabled="work_order_completed" 
              color="primary"
              depressed
              small
              @click="addingProduct=true"
            >
              <v-icon left x-small>fas fa-plus</v-icon>
              Agregar Producto
            </v-btn>
          </div>
        </template>
            <template v-slot:no-data>
              <v-alert :value="true"  icon="fas fa-info-circle" class="ma-4">
                Agregue Productos
              </v-alert>
            </template>
            <template v-slot:item.name="{item}">
            <ValidationProvider name="Nombre" rules="required|max:200" v-slot="{ errors }">  
              <v-textarea
                :hide-details="!errors.length > 0"
                rows="2"
                dense
                outlined
                v-model="item.name"
                class="my-2"
                :error-messages="errors"
                :disabled="work_order && item.production_product > 0"
              />
            </ValidationProvider> 
            </template>
            <template v-slot:item.qty="{item}">
              <ValidationProvider name="Cantidad" rules="required" v-slot="{ errors }">
                <v-text-field 
                  outlined
                  :hide-details="!errors.length > 0"
                  class="numeric-input"  
                  dense 
                  type="number" 
                  :min="1"
                  v-model="item.qty"
                  :error-messages="errors"
                  :disabled="work_order && item.production_product > 0"
                  style="max-width: 100px"
                />
              </ValidationProvider>
            </template>
            <template v-slot:item.totalMts2="{item}">
              {{item.totalMts2 | number('0,0.00')}}
            </template>
            <template  v-slot:item.unitCost="{item}">
              <strong v-if="item.sell_unit_m2"  class="cost" color-text="primary">{{(item.totalCost/item.totalMts2) | moneda}}</strong>
              <strong v-else class="cost" color-text="primary">{{(item.totalCost/item.qty) | moneda}}</strong>
              <!-- <strong class="cost" color-text="primary">{{item.unitCost | moneda}}</strong> -->
              <v-icon small class="ml-2">{{item.sell_unit_m2 ? 'square_foot':'view_comfy'}}</v-icon> 
            </template>
            <template v-slot:item.totalCost="{item}">
              <strong class="cost">{{item.totalCost | moneda}}</strong>
            </template>
        <template v-slot:item.price="{item}">
            <div class="d-flex align-center justify-end">
              <v-tooltip top v-if="(!item.is_margin && item.price_bellow_original) || (item.is_margin && item.margin_bellow_original)">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" small color="warning" class="mr-2">fas fa-exclamation-triangle</v-icon>
                </template>
                <span>Precio por debajo del sugerido</span>
              </v-tooltip>
              
              <div class="d-flex flex-column" style="max-width: 140px">
                <ValidationProvider name="Precio" rules="required" v-slot="{ errors }">
                  <v-text-field
                    hide-details="auto"
                    type="number"
                    :min="0"
                    outlined 
                    dense 
                    v-model="item.price"
                    :append-icon="item.sell_unit_m2 ? 'fas fa-vector-square' : 'fas fa-box'"
                    @click:append="item.sell_unit_m2 = !item.sell_unit_m2"
                    :error-messages="errors"
                    :readonly="item.margin_control"
                    class="price-input"
                  />
                </ValidationProvider>
                
                <div class="d-flex align-center mt-1" v-if="item.is_margin">
                  <v-checkbox
                    v-model="item.margin_control"
                    hide-details
                    dense
                    class="mt-0 pt-0 mr-1"
                    color="primary"
                  />
                  <v-text-field
                    class="margin-input" 
                    hide-details
                    type="number"
                    outlined 
                    dense
                    v-model="item.margin_price"
                    suffix="%"
                    :readonly="!item.margin_control"
                  />
                </div>
              </div>
            </div>
        </template>
        <template v-slot:item.totalPrice="{item}">
          <div class="text-right">
            <div :class="item.totalPrice >= item.totalCost ? 'success--text' : 'error--text'" class="font-weight-bold">
              {{item.totalPrice | moneda}}
            </div>
            <div v-if="item.totalPrice < item.totalCost" class="caption grey--text">Bajo costo</div>
          </div>
        </template> 
        <template v-slot:item.actions="{item}">
          <div class="d-flex justify-center">
            <v-btn icon x-small @click="duplicateProduct(item)" :disabled="work_order_completed" title="Duplicar item" class="mr-1">
              <v-icon x-small>fas fa-copy</v-icon>
            </v-btn>
            <v-btn icon x-small color="error" @click="removeProduct(item)" :disabled='work_order && item.production_product > 0' title="Eliminar item">
              <v-icon x-small>fas fa-trash-alt</v-icon>
            </v-btn>
          </div>
        </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="pa-8 grey lighten-5">
                <v-card outlined class="pa-6">
                  <v-row class="mb-4">
                    <v-col cols="12" md="3">
                      <ValidationProvider name="Ancho" rules="required|minvalue:0.1" v-slot="{ errors }">
                        <v-text-field
                          dense
                          label='Ancho (cm)'
                          type="number"
                          v-model='item.width'
                          prepend-inner-icon="fas fa-arrows-alt-h"
                          outlined
                          hide-details="auto"
                          :disabled="work_order && item.production_product > 0"
                          :error-messages="errors"
                        />
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="3">
                      <ValidationProvider name="Alto" rules="required|minvalue:0.1" v-slot="{ errors }">
                        <v-text-field
                          dense
                          label='Alto (cm)'
                          type="number"
                          v-model='item.height'
                          prepend-inner-icon="fas fa-arrows-alt-v"
                          outlined
                          hide-details="auto"
                          :disabled="work_order && item.production_product > 0"
                          :error-messages="errors"
                        />
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="3" align-self="center">
                      <div class="d-flex align-center">
                        <v-icon color="primary" small class="mr-2">fas fa-vector-square</v-icon>
                        <div>
                          <div class="text-overline grey--text lh-1">Área Unit.</div>
                          <div class="text-h6 font-weight-bold">{{item.unitMts2 | number('0.000')}} m²</div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  
                  <v-divider class="mb-6"></v-divider>

                  <v-row>
                    <v-col cols="12">
                      <recipe :mts2="item.totalMts2" :total="item.totalCost" :qty="item.qty" :items="item.recipe" :disabled="work_order && item.production_product > 0"/>
                    </v-col>
                    <v-col cols="12">
                      <supplies :product_width="item.width" :product_height="item.height" :mts2="item.totalMts2" :total="item.totalCost" :qty="item.qty" :items="item.product_supplies" :disabled="work_order && item.production_product > 0"/>
                    </v-col>
                  </v-row>

                  <v-row class="mt-4">
                    <v-col cols="12">
                      <ValidationProvider name="Observaciones Item" rules="max:500" v-slot="{ errors }">
                        <v-textarea
                          v-model="item.notes"
                          outlined
                          dense
                          label="Notas Técnicas del Item"
                          rows="2"
                          placeholder="Instrucciones especiales para producción..."
                          counter="500"
                          hide-details="auto"
                          :error-messages="errors"
                          background-color="white"
                          prepend-inner-icon="fas fa-sticky-note"
                        ></v-textarea>
                        <v-checkbox
                          v-model="item.not_show"
                          label="Esconder"
                          dense
                          hide-details
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-card>
              </td>
            </template>
            <template v-slot:item.not_show="{item}">
              
            </template>
          </v-data-table>
        </v-row>
        
        <v-row justify="center" class="my-6">
      <v-data-table
        :loading="loading"
        :headers="proyectCostsHeaders"
        :items="proyectCosts"
        item-key="key2"
        class="modern-table border rounded overflow-hidden elevation-0 mt-6 grow"
        hide-default-footer
      >
        <template v-slot:top>
          <div class="d-flex align-center px-4 py-3 bg-light border-bottom">
            <v-icon small class="mr-2" color="orange darken-2">fas fa-plus-circle</v-icon>
            <span class="text-subtitle-2 font-weight-bold">Costos Adicionales del Proyecto</span>
            <v-spacer></v-spacer>
            <v-btn 
              color="orange darken-2"
              dark
              depressed
              small
              @click="addingProyectCost=true"
            >
              <v-icon left x-small>fas fa-plus</v-icon>
              Agregar Costo
            </v-btn>
          </div>
        </template>
        <template v-slot:no-data>
          <v-alert type="info" text dense icon="fas fa-info-circle" class="ma-4">
            No se han registrado costos adicionales.
          </v-alert>
        </template>
        <template v-slot:item.name="{item}">
          <ValidationProvider name="Nombre" rules="required|max:200" v-slot="{ errors }">
            <v-textarea 
              hide-details="auto"
              class="my-2" 
              :error-messages="errors"
              outlined 
              dense 
              v-model="item.name" 
              rows="1"
              auto-grow
            />
          </ValidationProvider>
        </template>
        <template v-slot:item.qty="{item}">
          <ValidationProvider name="Cantidad" rules="required" v-slot="{ errors }">
            <v-text-field 
              outlined
              hide-details="auto"
              :disabled="item.unit==3||item.unit==1" 
              dense 
              type="number" 
              :min="0"
              v-model="item.qty"
              :error-messages="errors"
              class="text-right"
              style="max-width: 80px"
            />
          </ValidationProvider>
        </template>
        <template v-slot:item.unit="{item}">
           <v-chip x-small label outlined class="grey--text text--darken-2">
              {{item.cost_unit}}
          </v-chip>
        </template>
        <template v-slot:item.price="{item}">
          <ValidationProvider name="Precio" rules="required" v-slot="{ errors }">
            <v-text-field
              type="number"
              :min="0"
              hide-details="auto"               
              outlined 
              dense 
              v-model="item.sell_price"
              :error-messages="errors"
              class="text-right"
              style="max-width: 120px"
              suffix="$"
            ></v-text-field>
          </ValidationProvider>
        </template>
        <template v-slot:item.totalPrice="{item}">
          <div class="text-right font-weight-bold" :class="item.totalPrice >= item.totalCost ? 'success--text' : 'error--text'">
            {{item.totalPrice | moneda}}
          </div>
        </template> 
        <template v-slot:item.actions="{item}">
          <div class="d-flex justify-center">
            <v-btn icon x-small color="error" @click="deleteProyectCost(item)">
              <v-icon x-small>fas fa-trash-alt</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
        </v-row>
    <v-row class="mt-6">
      <v-col cols="12" md="6">
        <v-card outlined class="h-100 flex-grow-1">
          <div class="px-4 py-3 bg-light border-bottom d-flex align-center">
            <v-icon small class="mr-2">fas fa-paperclip</v-icon>
            <span class="text-subtitle-2 font-weight-bold">Documentos Adjuntos</span>
          </div>
          <v-card-text class="pa-0">
            <v-simple-table dense class="modern-table">  
              <tbody>
                <tr v-for="oldFile in oldFiles" :key="oldFile.url">
                  <td :class="oldFile.delete ? 'error lighten-5 opacity-50' : ''">
                    <div class="d-flex align-center py-1">
                      <v-icon x-small class="mr-2" :color="oldFile.delete ? 'error' : 'primary'">fas fa-file-alt</v-icon>
                      <a :href="oldFile.url" target="_blank" class="text-decoration-none" :class="oldFile.delete ? 'error--text' : ''">{{oldFile.name}}</a>
                    </div>
                  </td>
                  <td class="text-right" width="60">
                    <v-btn icon x-small :color="oldFile.delete ? 'primary' : 'error'" @click="oldFile.delete=!oldFile.delete">
                      <v-icon x-small>{{oldFile.delete ? 'fas fa-undo' : 'fas fa-trash-alt'}}</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <tr v-for="(file,index) in files" :key="`new-${index}`">
                  <td>
                    <div class="d-flex align-center py-1">
                      <v-icon x-small class="mr-2" color="success">fas fa-file-medical</v-icon>
                      <span class="success--text font-weight-medium">{{file.name}}</span>
                    </div>
                  </td>
                  <td class="text-right" width="60">
                    <v-btn icon x-small color="error" @click="removeLocalFile(file)">
                      <v-icon x-small>fas fa-times</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="pa-4">
                    <file-input @change="addFiles" class="mt-0" />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card outlined class="h-100 flex-grow-1">
          <div class="px-4 py-3 bg-light border-bottom d-flex align-center">
            <v-icon small class="mr-2">fas fa-comment-dots</v-icon>
            <span class="text-subtitle-2 font-weight-bold">Observaciones de la Cotización</span>
          </div>
          <v-card-text class="pa-4">
            <ValidationProvider name="Observaciones" rules="max:500" v-slot="{ errors }">
              <v-textarea
                v-model="notes"
                outlined
                dense
                rows="6"
                placeholder="Ingrese notas internas o detalles relevantes para esta cotización..."
                counter="500"
                hide-details="auto"
                :error-messages="errors"
                background-color="grey lighten-5"
              ></v-textarea>
            </ValidationProvider>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
      </v-form>
      </ValidationObserver>
    </div>
    
    <v-dialog v-model="addingProduct" max-width="1100">
      <v-card class="pa-10">
        <h1 class="titulo text text-h4"><v-icon x-large>add_shopping_cart</v-icon> Agregar Productos <span v-if="customer.name"><v-icon>arrow_right_alt</v-icon> <strong>{{customer.name}}</strong></span></h1>
        <v-row>
          <v-col>
            <add-product @close="addingProduct=false" @add="addProduct" :customer='this.customer'/>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addingProyectCost" max-width="500">
      <cost-create-update
      :cost=newProyectCost 
      @save="addProyectCost"
      @close="addingProyectCost = false"
      :custom='true'
      :global='true'
      />
    </v-dialog>
    <confirm 
    v-model="showConfirmSaveWithWorkOrder" 
    :message="'Al actualizar esta cotización se actualizará la Orden de Trabajo #'+work_order" 
    @ok="save"
    @cancel="showConfirmSaveWithWorkOrder=false"/>
  </v-container>
</template>

<script>
import CustomerComplete2 from '@/components/customers/CustomerComplete2'
import AddProduct from '@/components/products/products/AddProduct'
import Recipe from '@/components/products/products/Recipe'
import Supplies from '@/components/products/products/Supplies'
import notifications from '@/utils/notifications'
import CostCreateUpdate from '@/components/products/costs/CostCreateUpdate'
import DeliveryEstimation from '@/components/sales/DeliveryEstimation.vue'
import {getProduct} from '@/api/products'
import {createSalesNote,getSalesNote,updateSalesNote,fetchStatus} from '@/api/salesNotes'
import {getCustomer} from '@/api/customers'
import {productCost} from '@/utils/productCost'
import NumberLabel from '@/components/utils/NumberLabel'
import FileInput from '@/components/utils/FileInput'
import OriginSelection from '@/components/sales/OriginSelection.vue'

export default {
  name:'SalesNoteCreateUpdate',
  components:{CustomerComplete2,AddProduct,Recipe,Supplies,CostCreateUpdate,DeliveryEstimation,NumberLabel,FileInput,OriginSelection},
  
  data:()=>({
    id:-1,
    customer:'',
    contact:'',
    name:'',
    products:[],
    proyectCosts:[],
    discount:0,
    notes:'',
    status:'',
    created_at:'',
    created_by:'',
    updated_at:'',
    updated_by:'',
    status_list:'',
    closing_date:'',
    loading:false,
    saveLoading: false,
    addingProduct:false,
    addingProyectCost:false,
    newProyectCost:{
      id:-1,
      unit:'',
      name:'',
      price:0,
      min_price:0,
      is_supply:true,
      has_article:false,
      price_update_option:0
    },
    proyectCost:0,
    proyectMts2:0,
    proyectPrice:0,
    proyectTotalDiscount:0,
    proyectTotal:0,
    proyectMargin:0,
    salesNote:{},
    drawer:true,
    proyectCostsHeaders:[
      { text: 'Descripción', value: 'name' ,class:'table-header-dense'},
      { text: 'Cant.', value: 'qty',class:'table-header-dense' },
      { text: 'Unidad', value: 'unit' ,class:'table-header-dense'},
      { text: 'Cost. Unit.', value: 'unitCost' ,class:'table-header-dense'},
      { text: 'Cost. Total', value: 'totalCost',class:'table-header-dense' },
      { text: 'Prec. Unit.', value:'price',class:'table-header-dense'},
      { text: 'Prec. Total',value:'totalPrice',class:'table-header-dense'},
      { text: '', value: 'actions',class:'table-header-dense' },
     
    ],
    oldFiles:[],
    files:[],
    payment_condition:'',
    newFile:'',
    work_order:null,
    work_order_completed:false,
    showConfirmSaveWithWorkOrder:false,
  }),
  computed:{
    productsTableHeaders(){
      const header = [
      {text:'Código',value:'sku',class:'table-header-dense',available:true},
      { text: 'Desc.', value: 'name',class:'table-header-dense' ,available:true},
      { text: 'Cant.', value: 'qty' ,class:'table-header-dense product-quantity',align:'center', available:true},
      { text: 'Mts2', value: 'totalMts2' ,class:'table-header-dense',align:'end',available:true},
      { text: 'Costo', value: 'unitCost' ,class:'table-header-dense',align:'end',available:this.$can('readCost', 'SalesNote')},
      { text: 'Cost. Total', value: 'totalCost' ,class:'table-header-dense',align:'end',available:this.$can('readCost', 'SalesNote')},
      { text: 'Prec. Unit.', value:'price',class:'table-header-dense',align:'end',available:true,width:'180px'},
      { text: 'Prec. Total',value:'totalPrice',class:'table-header-dense',align:'end',available:true},
      { text: '', value: 'actions' ,class:'table-header-dense',available:true},
      { text: '', value: 'data-table-expand' ,class:'table-header-dense',available:true},
    ]
     return header.filter(item=>item.available)
    },
    exist_product_below_cost(){
      return this.products.some(item=>(item.totalCost/(item.sell_unit_m2?item.totalMts2:item.qty))>item.price)
    },
    exist_product_below_margin(){
      return this.products.some(item=>(item.margin_bellow_original))
    },
    exit_product_below_original_price(){
      return this.products.some(item=>(item.price_bellow_original))
    },
  },
  methods:{
    addFiles(files){
      this.files=[...this.files,...files]
    },
    removeLocalFile(file){
      this.files.splice(this.files.indexOf(file),1)
    },
    async addProduct(item){
      
      await getProduct(item.id)
      .then((product)=>{
        product.qty=1
        product.key=this.products.length +1
        product.notes=''
        product.original_price=product.price
        product.original_margin=product.margin_price
        product.price_bellow_original=false
        product.price_bellow_cost=false
        product.margin_bellow_original=false
        product.production_product=0
        if(product.is_margin) {
          product.margin_control=true
        }
        else{
          product.margin_control=false
        }
        this.$set(this.products,this.products.length,product)
      })
      .catch((e)=>{
          notifications.showError('Error cargando el producto' + e)
      })
    },
    removeProduct(item){
      const index=this.products.indexOf(item)
      this.products.splice(index, 1);
      //Correccion del key de los productos
      this.products.forEach((item,index)=>{
        item.key=index+1
      })
    },
    duplicateProduct(item){
      //solucion cochina para copiar un objeto sin referencia
      const newItem= JSON.parse(JSON.stringify(item))
      
      this.$set(this.products,this.products.length,{...newItem,production_product:0, key:this.products.length +1})
    }, 
    totals(){
      console.log('Calculando totals')
      this.loading=true
      //Calculo de totales por producto
      this.products.forEach(product=>{
        const productCostResults=productCost(product)
        const unit = productCostResults.unit
        const total = productCostResults.total
        const mts2 = productCostResults.totalMts2 
        const unitMts2=productCostResults.mts2 
        product.qty=parseInt(product.qty)||1
        //const calculatedUnitCost=product.sell_unit_m2?total/mts2:total/product.qty
        //Calculo de precio en caso que el producto tenga calculo con margen
        if (product.is_margin && product.margin_price!=0 && product.margin_control){
          product.price=(unit/(1-product.margin_price/100)).toFixed(2)
          product.sell_unit_m2=false
        }
        if (product.is_margin && product.margin_price!=0 && !product.margin_control){
          product.margin_price=100*(1-unit/product.price)
          product.sell_unit_m2=false
        }
        //const totalPrice = product.sell_unit_m2 ? product.price*mts2 : product.price*product.qty
        //Uso alternativa para redondear el precio unitario antes de multiplicar
        const totalPrice = product.sell_unit_m2 ? this.$options.filters.number(product.price,'0.00')*mts2 : this.$options.filters.number(product.price,'0.00')*product.qty

        this.$set(product, 'unitCost', unit)
        this.$set(product,'totalCost',total)
        this.$set(product,'totalMts2',mts2)
        this.$set(product,'unitMts2',unitMts2)
        this.$set(product,'totalPrice',totalPrice)

        //Coloca los flags de acuerdo al precio y costo
        this.$set(product,'price_bellow_original',parseFloat(product.price)<parseFloat(product.original_price))
        this.$set(product,'price_bellow_cost',parseFloat(product.totalPrice)<parseFloat(product.totalCost))
        this.$set(product,'margin_bellow_original',parseFloat(product.margin_price)<parseFloat(product.original_margin))

      })
      this.calculateProyectTotals()
      this.loading=false
    },
    calculateProyectTotals(){
      var proyectCost = 0
      var proyectMts2 = 0
      var proyectPrice = 0
      var totalDiscount = 0
      var proyectTotal = 0
      var proyectMargin = 0
      
      //Suma a los totales los costos por producto
      this.products.map(product=>{
        proyectCost  +=product.totalCost
        proyectMts2 +=product.totalMts2
        proyectPrice +=product.totalPrice
      })

      //Suma costos adicionales del Proyecto
      this.proyectCosts.map(cost => { 
        proyectCost+=cost.totalCost
        proyectPrice +=cost.totalPrice 
      })
      //Calcula los totales con el descuento
      totalDiscount = proyectPrice*this.discount/100
      proyectTotal=proyectPrice-totalDiscount
      //Calcula el Margen
      proyectMargin=1-proyectCost/proyectTotal
      
      this.proyectCost = proyectCost
      this.proyectMts2 = proyectMts2
      this.proyectPrice = proyectPrice
      this.proyectTotalDiscount = totalDiscount
      this.proyectMargin = proyectMargin
      this.proyectTotal=proyectTotal
    },
    calculateProyectCosts(){
      this.loading=true
      this.proyectCosts.map(cost => {
        var unitCost = 0
        var totalCost = 0
        var totalPrice = 0
        if(cost.unit==1){
          //Verifica si la unidad es por m2
          unitCost = cost.price
          totalCost=unitCost*this.proyectMts2
          totalPrice=cost.sell_price*this.proyectMts2 
        }
        else{
          unitCost = cost.price
          totalCost=unitCost*cost.qty
          totalPrice=cost.sell_price*cost.qty
        }
        this.$set(cost,'unitCost',unitCost)
        this.$set(cost,'totalCost',totalCost)
        this.$set(cost,'totalPrice',totalPrice)  
      })
      //Recalcula los totales por proyecto
      this.calculateProyectTotals()
      this.loading=false
    },
    async save(){
      //Chequeo que todos los productos tengan al menos un proceso
      var error_process_length=false
      this.products.map(product=>{
        // if (product.product_receta.length<1) {
        //   error_process_length=true
        // }
        //Cambio a la propiedad recipe
        if (product.recipe.length<1) {
          error_process_length=true
        }
      })
      if (error_process_length){
        notifications.showError("Los productos tienen que poseer al menos un proceso")
        return 0
      } 
      //---------------------------------------------------------
      //Chequeo si el producto escondido debe tener precio 0
      var error_price_hidden=false
      this.products.map(product=>{
        if (product.not_show && product.price>0) {
          error_price_hidden=true
        }
      })
      if (error_price_hidden){
        notifications.showError("Los productos escondidos deben tener precio 0")
        return 0
      }
      //---------------------------------------------------------
      //Chequeo si existe producto debajo del margen
      if (this.exist_product_below_margin && !this.$can('save_product_below_margin', 'SalesNote')){
        notifications.showError("Existen productos con margen por debajo del original")
        return 0
      }
      //---------------------------------------------------------
      //Chequeo si existe producto debajo del precio original
      if (this.exit_product_below_original_price && !this.$can('save_product_below_price', 'SalesNote')){
        notifications.showError("Existen productos con precio por debajo del original")
        return 0
      }
      //---------------------------------------------------------
      
      this.saveLoading=true

      var formData=new FormData()
        formData.append('customer', this.customer.id)
        formData.append('contact', this.contact)
        formData.append('name', this.name)
        formData.append('payment_condition', this.payment_condition)
        formData.append('closing_date', this.closing_date)
        formData.append('origin', this.origin)
        formData.append('details', JSON.stringify({
          products:this.products,
          costs:this.proyectCosts,
          notes:this.notes
        }))
        formData.append('totals', JSON.stringify({
          cost: this.proyectCost,
          mts2: this.proyectMts2,
          price: this.proyectPrice,
          discount: this.discount || 0,
          totalDiscount:this.proyectTotalDiscount,
          margin:this.proyectMargin,
          total: this.proyectTotal
        }))
        this.files.forEach(file => {
          formData.append(`file${this.files.indexOf(file)}`, file)
        })
        

      if(this.id>0){
        //Creando objeto para actualizar
        //Agrego lista de archivos antiguos para revisar cual eliminar
        formData.append('oldFiles', JSON.stringify(this.oldFiles))

        await updateSalesNote(this.id,formData)
        .then(()=>{
          this.$router.push('/sales')
          notifications.showSuccess('Cotización Guardada con Exito!')
          this.saveLoading = false
        })
        .catch((e)=>{
          notifications.showError('Error Actualizando Cotización '+e)
          this.saveLoading = false
        })
      }
      else{
        //considera que es una nueva nota
        await createSalesNote(formData)
        .then(()=>{
          this.$router.push('/sales')
          notifications.showSuccess('Cotización Creada con Exito!')
          this.saveLoading = false
        })
        .catch((e)=>{
          notifications.showError('Error Cotización '+e)
          this.saveLoading = false
        })
      }
    },
    //Función para añadir costos adicionales al proyecto
    addProyectCost(item){
      console.log(item)
      const cost={
        id:item.id,
        price:item.price,
        sell_price:item.price,
        unit:item.unit,
        cost_unit:item.unit_name,
        name: item.name,
        qty:1,
      }
      this.proyectCosts.push(cost)
      this.newProyectCost={
        id:-1,
        unit:'',
        name:'',
        price:0,
        min_price:0,
        is_supply:true
      }
      this.addingProyectCost=false
    },
    deleteProyectCost(item){
      const index = this.proyectCosts.indexOf(item);
      this.proyectCosts.splice(index, 1);
    },
    //Duplica la NV presente
    duplicate(){
      this.$router.push({name:'SalesNoteCreateUpdate',params:{id:this.id, duplicate:true}})
    },
  },
  watch:{
    //Revisa cambios en producto para activar calculo de totales
    products:{
      deep: true,
      handler: 'totals'
    },
    //Revisa cambios en proyecto para activar el calculo de totales
    proyectCosts:{
      deep: true,
      handler: 'calculateProyectCosts'
    },
    //Revisa cambios en cantidad de Mts2 para recalcular costos
    proyectMts2:{
      handler: 'calculateProyectCosts'
    },
    customer(){
      this.payment_condition=this.customer.payment==0?'Contado':`${this.customer.payment} días`
    },
    
  },
  async mounted(){
    if(this.$route.params.id){
      this.loading=true
      await getSalesNote(this.$route.params.id)
      .then(async salesNote=>{
        if(salesNote.customer){
          await getCustomer(salesNote.customer)
          .then((customer)=>{
            this.customer = customer
          })
        }
        //Guardo la nota de venta completa para usar para PDF y otros comandos
        this.salesNote = salesNote

        //Llevo los datos al template

        this.contact=salesNote.contact
        this.id=salesNote.id
        this.name=salesNote.name
        this.payment_condition=salesNote.payment_condition
        this.products=salesNote.details.products
        this.notes=salesNote.details.notes
        this.discount=salesNote.totals.discount
        this.status=salesNote.status
        this.created_at=salesNote.created_at
        this.closing_date=salesNote.closing_date
        this.origin=salesNote.origin
        this.created_by=salesNote.created_by.first_name + ' ' + salesNote.created_by.last_name
        this.updated_at=salesNote.updated_at
        this.updated_by=salesNote.created_by.first_name + ' ' + salesNote.created_by.last_name
        this.proyectCosts=salesNote.details.costs
        this.work_order=salesNote.work_order
        this.work_order_completed=salesNote.work_order_completed
        this.oldFiles=salesNote.files.map(f=>{
          return {
            ...f,delete:false
          }
        })
      })
    }
    //Verifica si quiero duplicar una nota de venta
    //y establezco el id en estado de nueva nota
    if(this.$route.params.duplicate){
      this.name='(Copia) '+this.name 
      this.id=-1
      this.work_order=null
      //Establezco el estado de la nota en pendiente
      this.status='pending'
      //Si duplico vuelvo a establecer los production_product en 0
      this.products=this.products.map(product=>{
        product.production_product=0
        return product})
    }
    // this.status_list=await fetchStatus()
  }
}

</script>

<style lang="scss" scoped>
  
  .discount{
    width: 6rem !important;
    .v-input__control{
      .v-text-field__details{
      min-height: 0px !important;
      padding: 0 !important;
      margin-bottom: 0px !important;
      .v-messages{
      min-height: 0px !important;
      }
    }
    }
  }
  .product-quantity {
    width: 100px;
    display: flex-end;
  }
  .v-text-field__slot input{
    text-align: right;
    color: primary;
  }
</style>